export default {
  C202a: ['C2.02a_ND112020_31', 'C2.02a_ND112020_34', 'C2.02a_ND112020_165'], // 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
  C202b: ['C2.02b_ND112020_31', 'C2.02b_ND112020_34', 'C2.02b_ND112020_165'], // 'C2-02b/NS: Giấy rút dự toán ngân sách (Nghị định 11/2020/NĐ-CP)',
  Ms07: [
    '56.01.ND11.2020_31',
    '56.01.ND11.2020_34',
    '56.01.ND11.2020_165',
    '56.01.ND11.2020_104',
    '56.01.ND11.2020_Vertical_31',
    '56.01.ND11.2020_Vertical_34',
    '56.01.ND11.2020_Vertical_104',
    '56.01.ND11.2020_Vertical_165',
  ], // 'Mẫu số 07: Bảng kê nội dung thanh toán tạm ứng',
  C402a: ['c4-02a_kb_33', 'c4-02a_kb_31', 'c4-02a_kb_20'], //'C4-02a/NS: Ủy nhiệm chi chuyển khoản, chuyển tiền điện tử', kbnguyet - bổ sung thêm id báo cáo c402a in ở Phiếu rút tiền KB, Phiếu thu
  C402c: ['c4-02c_kb_33'], //'C4-02c/NS: Ủy nhiệm chi chuyển khoản, chuyển tiền điện tử ',
  M05tt: ['05_TT_ND99_31', '05_TT_ND99_34'], // 'Mẫu 05TT: Giấy rút vốn đầu tư (Nghị định 99/2021/NĐ-CP)',
  C203: ['C203_ND11'], //'C2-03/NS: Giấy đề nghị thanh toán tạm ứng/ứng trước (Nghị định 11/2020/NĐ-CP)',
  C205a: ['c205a_nd112020_33', 'c205a_nd112020_21', 'c205a_nd112020_30'], // 'C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)',
  M04att: ['04aTT_ND992021'], //'Mẫu 04.a.TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
  M04btt: ['04_b_tt_nd992021'], //'Mẫu 04.b.TT: Giấy đề nghị thu hồi vốn (Nghị định 99/2021/NĐ-CP)',
};
